export default __webpack_public_path__ + "static/services-marbel-7af750f4e9f2868d66d9460951a8cd9e.png";